export const navLinks = [
  { id: "nav-hero", label: "首页", href: "#top" },
  { id: "nav-proof", label: "实锤速览", href: "#proof" },
  { id: "nav-events", label: "事件归组", href: "#events" },
  { id: "nav-library", label: "材料库", href: "#library" },
  { id: "nav-timeline", label: "更新节奏", href: "#timeline" },
  { id: "nav-subscribe", label: "订阅更新", href: "#subscribe" },
];

export const tickerItems = [
  "实锤材料按事件归组",
  "聊天记录保留原始时间戳",
  "截图标明来源与截图时间",
  "录音文件附文字转写",
  "每份材料可单独查看原始内容",
  "结论标签与材料分开呈现",
];

export const evidenceTypes = [
  {
    id: "type-proof",
    icon: "ri-hammer-line",
    name: "实锤归档",
    brief: "把可交叉验证的关键材料单独抽出，形成一条能反复对照的链路。",
    count: "326 组",
    unit: "可交叉验证",
    href: "#proof",
  },
  {
    id: "type-chat",
    icon: "ri-chat-3-line",
    name: "聊天记录",
    brief: "保留对话上下文与原始时间戳，避免只截图其中一句话造成误读。",
    count: "1,184 段",
    unit: "含上下文",
    href: "#library",
  },
  {
    id: "type-shot",
    icon: "ri-image-2-line",
    name: "截图对照",
    brief: "同一事件的多张截图并排呈现，标注来源页面与获取时间。",
    count: "2,057 张",
    unit: "标注来源",
    href: "#library",
  },
  {
    id: "type-audio",
    icon: "ri-mic-line",
    name: "录音留档",
    brief: "音频附文字转写与时长说明，方便先看文字再决定是否听原音。",
    count: "418 条",
    unit: "附转写",
    href: "#library",
  },
];

export const featuredStacks = [
  {
    id: "stack-01",
    seq: "EV-2609-114",
    tag: "持续更新",
    title: "直播间合作分成争议：从口头约定到对账记录",
    summary:
      "事件围绕一份未落地的分成约定展开，材料从最初的私聊沟通，延伸到后续的转账备注与对账表格，时间跨度约四个月。",
    image:
      "https://readdy.ai/api/search-image?query=top%20down%20flat%20lay%20of%20stacked%20printed%20documents%20and%20a%20folder%20on%20a%20warm%20textured%20desk%2C%20soft%20window%20light%2C%20muted%20vermillion%20accent%2C%20editorial%20still%20life%2C%20restrained%20composition%2C%20no%20people&width=1200&height=760&seq=blackproof-stack-01&orientation=landscape",
    stats: [
      { label: "聊天记录", value: "36 段" },
      { label: "截图", value: "58 张" },
      { label: "录音", value: "3 条" },
    ],
    updatedAt: "09-11 21:40",
  },
  {
    id: "stack-02",
    seq: "EV-2609-107",
    tag: "待核",
    title: "账号代运营纠纷：后台数据与对外口径不一致",
    summary:
      "同一时间段的运营后台数据，与对外沟通中引用的数字存在明显出入，材料包含后台导出截图与沟通原文。",
    image:
      "https://readdy.ai/api/search-image?query=abstract%20dark%20analytics%20dashboard%20glow%20on%20a%20matte%20surface%20with%20scattered%20paper%20notes%2C%20warm%20amber%20and%20deep%20red%20tones%2C%20minimal%20editorial%20product%20photography%2C%20soft%20shadow%2C%20no%20people&width=1200&height=760&seq=blackproof-stack-02&orientation=landscape",
    stats: [
      { label: "聊天记录", value: "22 段" },
      { label: "截图", value: "41 张" },
      { label: "录音", value: "0 条" },
    ],
    updatedAt: "09-10 18:05",
  },
  {
    id: "stack-03",
    seq: "EV-2609-096",
    tag: "已归档",
    title: "线下活动临时取消：通知时间线与报名记录",
    summary:
      "活动取消通知的实际发出时间，与报名用户收到的回复时间存在先后差异，材料按时间顺序排列。",
    image:
      "https://readdy.ai/api/search-image?query=closed%20notebook%20and%20a%20single%20red%20pen%20resting%20on%20a%20plain%20cream%20desk%2C%20quiet%20negative%20space%2C%20warm%20neutral%20palette%2C%20editorial%20minimal%20still%20life%2C%20no%20people&width=1200&height=760&seq=blackproof-stack-03&orientation=landscape",
    stats: [
      { label: "聊天记录", value: "14 段" },
      { label: "截图", value: "19 张" },
      { label: "录音", value: "1 条" },
    ],
    updatedAt: "09-08 09:12",
  },
];

export const eventGroups = [
  {
    id: "EV-2609-114",
    title: "直播间合作分成争议",
    angle: "围绕分成约定与对账记录展开",
    status: "持续更新",
    chat: 36,
    shot: 58,
    audio: 3,
    updatedAt: "09-11 21:40",
  },
  {
    id: "EV-2609-107",
    title: "账号代运营纠纷",
    angle: "后台数据与对外口径不一致",
    status: "待核",
    chat: 22,
    shot: 41,
    audio: 0,
    updatedAt: "09-10 18:05",
  },
  {
    id: "EV-2609-096",
    title: "线下活动临时取消",
    angle: "通知时间线与报名记录错位",
    status: "已归档",
    chat: 14,
    shot: 19,
    audio: 1,
    updatedAt: "09-08 09:12",
  },
  {
    id: "EV-2609-088",
    title: "货源承诺与实物不符",
    angle: "宣传文案与实物对照",
    status: "持续更新",
    chat: 27,
    shot: 63,
    audio: 2,
    updatedAt: "09-06 14:33",
  },
  {
    id: "EV-2609-071",
    title: "兼职结算延期说明",
    angle: "结算节点与沟通记录对照",
    status: "已归档",
    chat: 18,
    shot: 24,
    audio: 0,
    updatedAt: "09-03 11:02",
  },
];

export const materialFilters = [
  { id: "all", label: "全部材料" },
  { id: "chat", label: "聊天记录" },
  { id: "shot", label: "截图" },
  { id: "audio", label: "录音" },
  { id: "proof", label: "实锤" },
];

export const materials = [
  {
    id: "m-01",
    type: "proof",
    typeLabel: "实锤",
    icon: "ri-hammer-line",
    title: "分成比例确认的关键对话与后续转账备注",
    event: "EV-2609-114",
    source: "原始私聊 · 含时间戳",
    size: "36 段对话",
    time: "09-11 21:40",
  },
  {
    id: "m-02",
    type: "shot",
    typeLabel: "截图",
    icon: "ri-image-2-line",
    title: "后台导出页与对外引用数字对照图",
    event: "EV-2609-107",
    source: "后台导出 · 已标注截图时间",
    size: "41 张",
    time: "09-10 18:05",
  },
  {
    id: "m-03",
    type: "audio",
    typeLabel: "录音",
    icon: "ri-mic-line",
    title: "沟通录音片段与完整文字转写",
    event: "EV-2609-114",
    source: "录音原件 · 附转写",
    size: "12 分 08 秒",
    time: "09-11 20:12",
  },
  {
    id: "m-04",
    type: "chat",
    typeLabel: "聊天记录",
    icon: "ri-chat-3-line",
    title: "活动取消通知发出前后的完整对话链",
    event: "EV-2609-096",
    source: "群聊原文 · 保留上下文",
    size: "14 段对话",
    time: "09-08 09:12",
  },
  {
    id: "m-05",
    type: "shot",
    typeLabel: "截图",
    icon: "ri-image-2-line",
    title: "宣传文案与实物实拍并排对照",
    event: "EV-2609-088",
    source: "页面存档 · 含获取时间",
    size: "63 张",
    time: "09-06 14:33",
  },
  {
    id: "m-06",
    type: "proof",
    typeLabel: "实锤",
    icon: "ri-hammer-line",
    title: "结算节点与沟通记录的交叉核对表",
    event: "EV-2609-071",
    source: "表格原件 · 可逐条对照",
    size: "18 段对话",
    time: "09-03 11:02",
  },
  {
    id: "m-07",
    type: "audio",
    typeLabel: "录音",
    icon: "ri-mic-line",
    title: "货源承诺现场沟通录音留档",
    event: "EV-2609-088",
    source: "录音原件 · 附转写",
    size: "06 分 41 秒",
    time: "09-05 16:20",
  },
  {
    id: "m-08",
    type: "chat",
    typeLabel: "聊天记录",
    icon: "ri-chat-3-line",
    title: "代运营对接阶段的完整沟通记录",
    event: "EV-2609-107",
    source: "原始私聊 · 含时间戳",
    size: "22 段对话",
    time: "09-10 18:05",
  },
];

export const timelineItems = [
  {
    id: "tl-01",
    time: "09-11 21:40",
    title: "补充对账记录",
    desc: "EV-2609-114 新增转账备注截图 9 张，材料链路补齐至对账环节。",
    tag: "新增材料",
  },
  {
    id: "tl-02",
    time: "09-10 18:05",
    title: "后台数据核对",
    desc: "EV-2609-107 完成后台导出与对外口径的逐项比对，标记 3 处明显出入。",
    tag: "交叉核对",
  },
  {
    id: "tl-03",
    time: "09-08 09:12",
    title: "事件归入归档",
    desc: "EV-2609-096 通知时间线整理完毕，状态标记为已归档，材料不再追加。",
    tag: "状态变更",
  },
  {
    id: "tl-04",
    time: "09-06 14:33",
    title: "实物对照上传",
    desc: "EV-2609-088 宣传文案与实物实拍并排发布，共 63 张对照图。",
    tag: "新增材料",
  },
  {
    id: "tl-05",
    time: "09-03 11:02",
    title: "录音转写完成",
    desc: "EV-2609-071 录音完成人工转写，与结算节点表完成交叉标注。",
    tag: "转写完成",
  },
];

export const footerColumns = [
  {
    id: "col-1",
    title: "浏览入口",
    links: [
      { id: "f-1", label: "实锤速览", href: "#proof" },
      { id: "f-2", label: "事件归组", href: "#events" },
      { id: "f-3", label: "材料库", href: "#library" },
      { id: "f-4", label: "更新节奏", href: "#timeline" },
    ],
  },
  {
    id: "col-2",
    title: "材料类型",
    links: [
      { id: "f-5", label: "实锤归档", href: "#proof" },
      { id: "f-6", label: "聊天记录", href: "#library" },
      { id: "f-7", label: "截图对照", href: "#library" },
      { id: "f-8", label: "录音留档", href: "#library" },
    ],
  },
  {
    id: "col-3",
    title: "整理说明",
    links: [
      { id: "f-9", label: "材料归组方式", href: "#events" },
      { id: "f-10", label: "来源标注约定", href: "#library" },
      { id: "f-11", label: "订阅更新", href: "#subscribe" },
      { id: "f-12", label: "内容边界声明", href: "#disclaimer" },
    ],
  },
];